import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { detailsActions } from "../../../store/details"

export default function PatientsTabsOnPageChange({activeTab, tabs}) {
    const dispatch = useDispatch()
 
    useEffect(() => {
        const safeTabs = Array.isArray(tabs) ? tabs.filter((item) => item && item.id != null) : []
        
        // 15 == Appointments
        // 26 == Flags
        // 27 == History
        // 36 == Alerts
        if (safeTabs.length > 0 && activeTab !== 15 && activeTab !== 26 && activeTab !== 27 && activeTab !== 36) {
            const active = safeTabs.filter((item) => item.id === activeTab)

            if (!active || active.length === 0) {
                dispatch(detailsActions.setActiveTab(safeTabs[0].id))
            }
        }
    }, [activeTab, tabs, dispatch])
    return null
}